import { render, staticRenderFns } from "./DetailHeaderButtons.vue?vue&type=template&id=4c44febf&scoped=true&"
import script from "./DetailHeaderButtons.vue?vue&type=script&lang=js&"
export * from "./DetailHeaderButtons.vue?vue&type=script&lang=js&"
import style0 from "./DetailHeaderButtons.vue?vue&type=style&index=0&id=4c44febf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c44febf",
  null
  
)

export default component.exports